<template>
  <div>
    <el-card class="box" body-style="">
      <div
        style="
          height: 40px;
          display: flex;
          font-size: 18px;
          font-weight: bold;
          align-items: center;
        "
      >
        <div style="margin-right: 10px">
          <el-button type="primary" @click="$router.go(-1)"
            ><i class="el-icon-back" style="margin-right: 10px"></i>
            后退前页</el-button
          >
        </div>
        <div style="color: #000">
          <span style="cursor: pointer" @click="$router.go(-1)">{{
            backName || '工作台'
          }}</span>
          <i class="el-icon-arrow-right"></i>
        </div>
        <div style="color: #606266" class="ellipsis">项目移交</div>
      </div>
      <div class="box-content">
        <div class="search-box">
          <div class="search">
            <el-input
              placeholder="请输入移交任务名称"
              v-model="searchData.Name"
              clearable
              style="width: 300px; margin-right: 10px"
            ></el-input>
            <el-date-picker
              style="width: 300px; margin-right: 10px"
              v-model="searchData.CreateTime"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="创建开始日期"
              end-placeholder="创建结束日期"
            >
            </el-date-picker>
            <el-select
              v-model="searchData.Status"
              filterable
              clearable
              placeholder="请选择状态"
              style="width: 200px; margin-right: 10px"
            >
              <el-option label="未开始" value="0"></el-option>
              <el-option label="开始移交" value="1"></el-option>
              <el-option label="移交完成" value="2"></el-option>
            </el-select>
            <el-button type="primary" @click="search" :loading="loading"
              >查询</el-button
            >
          </div>
          <div>
         
            <el-button type="success" icon="el-icon-s-claim"  v-if="ProjectInfo.ProjectStatus!==2"
            :loading="loading" @click="ProjectFinish">项目完结</el-button>
            <el-button
              type="primary"
              @click="openReport('项目')"
              :loading="loading"
              icon="el-icon-tickets"
              >项目报告</el-button
            >
            <el-button
              type="primary"
              @click="openReport('供应商')"
              :loading="loading"
              icon="el-icon-tickets"
              >供应商报告</el-button
            >
            <el-button
              type="primary"
              @click="addData"
              :loading="loading"
              icon="el-icon-plus"
              v-if="ProjectInfo.ProjectStatus !== 2"
              >添加移交任务</el-button
            >
          </div>
        </div>
        <el-table
          :data="tableData"
          ref="table"
          size="mini"
          row-key="Id"
          v-loading="loading"
          height="calc(100% - 100px)"
          style="width: 100%; margin-top: 10px"
          @selection-change="handleRightSelectionChange"
          @row-click="handleRightRowClick"
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="checkSelectable"
          >
          </el-table-column>
          <el-table-column
            type="index"
            width="50"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column label="移交任务名称" prop="Name" sortable>
          </el-table-column>
          <el-table-column
            label="供应商名称"
            prop="SupplierName"
            width="350px"
            align="center"
            sortable
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="设备"
            prop="DeviceQty"
            width="110"
            align="right"
            sortable
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="配件"
            prop="AccessoryQty"
            width="110"
            align="right"
            sortable
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="项目资料"
            prop="ProjectFilesQty"
            width="110"
            align="right"
            sortable
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="资质资料"
            prop="SupFilesQty"
            width="110"
            align="right"
            sortable
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            label="创建人"
            prop="CreatorName"
            width="130"
            align="center"
            sortable
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="CreateTime"
            width="130"
            align="center"
            sortable
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ moment(scope.row.CreateTime).format('YYYY-MM-DD HH:mm') }}
            </template>
          </el-table-column>
          <el-table-column
            label="移交时间"
            prop="HandOverDate"
            width="130"
            align="center"
            sortable
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.HandOverDate
                  ? moment(scope.row.HandOverDate).format('YYYY-MM-DD HH:mm')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="完成时间"
            prop="CompleteDate"
            width="130"
            align="center"
            sortable
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{
                scope.row.CompleteDate
                  ? moment(scope.row.CompleteDate).format('YYYY-MM-DD HH:mm')
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column
            label="移交任务状态"
            prop="Status"
            width="130"
            align="center"
            sortable
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.Status == 0">未开始</el-tag>

              <el-tag type="warning" v-if="scope.row.Status == 1"
                >开始移交</el-tag
              >
              <el-tag type="success" v-if="scope.row.Status == 2"
                >移交完成</el-tag
              >
            </template>
          </el-table-column>

          <el-table-column prop="op" width="200" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click.stop="startData(scope.row)"
                type="text"
                v-if="scope.row.Status == 0"
                >开始移交</el-button
              >
              <el-button @click.stop="viewData(scope.row)" type="text"
                >详情</el-button
              >
              <el-button
                @click.stop="deleteData(scope.row)"
                type="text"
                style="color: #f56c6c"
                v-if="scope.row.Status == 0"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            height: 40px;
            border-top: 1px solid #ccc;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div class="el-pagination__total">
            共 {{ tableData.length }} 次移交任务
          </div>
          <div class="el-pagination__total">
            设备数量总计：
            {{ tableData.reduce((acc, cur) => acc + cur.DeviceQty, 0) }}
          </div>
          <div class="el-pagination__total">
            配件数量总计：
            {{ tableData.reduce((acc, cur) => acc + cur.AccessoryQty, 0) }}
          </div>
          <div class="el-pagination__total">
            项目资料数量总计：
            {{ tableData.reduce((acc, cur) => acc + cur.ProjectFilesQty, 0) }}
          </div>
          <div class="el-pagination__total">
            资质资料数量总计：
            {{ tableData.reduce((acc, cur) => acc + cur.SupFilesQty, 0) }}
          </div>
        </div>
      </div>
    </el-card>
    <EditHandOver
      ref="EditHandOver"
      :pId="pId"
      @success="search"
    ></EditHandOver>
    <ViewHandOver ref="ViewHandOver"></ViewHandOver>
    <el-drawer
      :visible.sync="visible"
      direction="rtl"
      size="100%"
      :withHeader="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <ProjectInspect
        ref="ProjectInspect"
        v-if="visible"
        :row="row"
        @show="visible = false"
        :taskId="TaskId"
        @successSub="successSub"
      ></ProjectInspect>
    </el-drawer>
    <el-drawer
      :visible.sync="ReportVisible"
      direction="rtl"
      size="100%"
      :withHeader="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <ProjectTextReport
        ref="ProjectTextReport"
        :pId="pId"
        :taskId="TaskIdList"
        :isShowLeft="isShowLeft"
        :isShowBut="false"
        :isShowClose="true"
        v-if="ReportVisible === true"
        @close="ReportVisible = false"
      ></ProjectTextReport>
    </el-drawer>
  </div>
</template>
<script>
import moment from 'moment'

import EditHandOver from './EditHandOver'
import ViewHandOver from './ViewHandOver'
import ProjectInspect from './ProjectInspect'
import ProjectTextReport from '@/views/Project/ProjectTextReport/ProjectTextReport.vue'
import { Loading } from 'element-ui'
export default {
  data() {
    return {
      moment,
      searchData: {
        Name: '',
        CreateTime: '',
        Status: '',
      },
      visible: false,
      tableData: [],
      ProjectInfoLoading: false,
      ProjectInfo: {
        ProjectStatus: 2,
      },
      loading: false,
      backName: '',
      pId: '',
      TaskId: '',
      row: {},
      multipleSelection: [],
      ReportVisible: false,
      TaskIdList: '',
      isShowLeft: false,
    }
  },
  props: {},
  components: { EditHandOver, ViewHandOver, ProjectInspect, ProjectTextReport },
  methods: {
    ProjectFinish() {
      console.log('项目完结')
      this.$confirm('确认完结当前项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let loadingInstance = Loading.service({
          fullscreen: true,
          lock: true,
          text: '完结检查中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })

        this.$http
          .post(`/Base_ProjectWork/Base_Project/ProjectClosing`, {
            id: this.entity.Id,
          })
          .then((res) => {
            loadingInstance.close()
            if (res.Success) {
              this.$notify.success('操作成功！项目已完结')
              this.$router.go(-1)
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    openReport(text) {
      console.log(this.multipleSelection, 'multipleSelection')
      if (this.multipleSelection.length > 0) {
        this.TaskIdList = this.multipleSelection
          .map((item) => item.Id)
          .join(',')
        if (text === '供应商') {
          this.isShowLeft = true
        } else {
          this.isShowLeft = false
        }
        this.ReportVisible = true
      } else {
        this.$notify.error('请选择移交任务')
      }
    },
    successSub() {
      this.getDataList()
    },
    // 检查行是否可选择
    checkSelectable(row) {
      return row.Status != 0
    },
    handleRightSelectionChange(val) {
      this.multipleSelection = val
    },
    handleRightRowClick(row) {
      if (row.Status != 0) {
        this.$refs.table.toggleRowSelection(row)
      }
    },
    startData(row) {
      this.row = { ...row }
      this.TaskId = row.Id
      this.visible = true
      // this.$refs.ProjectInspect.open(row.Name, row.Id)
    },
    viewData(row) {
      this.$refs.ViewHandOver.open(row)
    },
    deleteData(row) {
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http
          .post(
            `/Base_ProjectWork/project_taskhandover/DeleteTaskHandoverData?id=${row.Id}`,
            {
              data: {
                Id: row.Id,
              },
            }
          )
          .then((res) => {
            if (res.Success) {
              this.$notify.success('删除成功')
              this.getDataList()
            } else {
              this.$notify.error(res.Msg)
            }
          })
      })
    },
    addData() {
      this.$refs.EditHandOver.open('添加移交任务')
    },
    search() {
      this.getDataList()
    },
    getDataList() {
      this.loading = true
      this.$http
        .post(
          '/Base_ProjectWork/project_taskhandover/GetprojecttaskhandoverList',
          {
            Search: [
              {
                Condition: 'ProjectId',
                Keyword: this.pId,
              },

              {
                Condition: 'Name',
                Keyword: this.searchData.Name,
              },
              {
                Condition: 'CreateTime',
                Keyword: this.searchData.CreateTime
                  ? this.searchData.CreateTime.join(',')
                  : '',
              },
              {
                Condition: 'Status',
                Keyword: this.searchData.Status,
              },
            ],
          }
        )
        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.tableData = res.Data
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    getProjectInfo() {
      this.ProjectInfoLoading = true
      this.$http
        .post('/Base_ProjectWork/Base_Project/GetTheData', {
          Id: this.pId,
        })
        .then((res) => {
          this.ProjectInfoLoading = false
          if (res.Success) {
            this.ProjectInfo = res.Data
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
  },
  mounted() {},
  async created() {
    this.pId = this.$route.query.id
    this.backName = this.$route.query.name
    this.getDataList()
    this.getProjectInfo()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .box .el-card__body {
  height: calc(100vh - 70px);

  padding: 0px 20px;
  padding-bottom: 0px;
}
.box-content {
  height: calc(100% - 40px);
}
.search-box {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .search {
    display: flex;
    flex: 1;
  }
}
.el-pagination__total {
  margin-right: 20px;
}
</style>
